import { usersCollection } from "../../config/firebase";
import { RepositoryFactory } from "../../repository/RepositoryFactory";
import { baseDomain } from '../../variables';
let SubscriptionRepository = RepositoryFactory.get('subscription');
let state = {
	subscription: {},
	subscriptions: [],
	loading: false,
	notification: { message: '', type: '' },
};
let getters = {
	subscription: state => state.subscription,
	subscriptions: state => state.subscriptions,
	subscriptionLoading: state => state.loading,
	subscriptionNotification: state => state.notification,
};
let actions = {
	async getSubscription({ commit }, payload) {
		commit('setSubscriptionLoading', true);
		let { data } = await SubscriptionRepository.one(payload);

		commit('setSubscriptionsData', data);
		commit('setSubscriptionLoading', false);
	},
	async getSubscriptions({ commit }) {
		commit('setSubscriptionLoading', true);
		let { data } = await SubscriptionRepository.get();

		let { data: innerData } = data;
		innerData.sort((a, b) => a.unit_amount - b.unit_amount);
		data['data'] = innerData;
		commit('setSubscriptionsData', data);
		commit('setSubscriptionLoading', false);
	},
	async createSubscription({ commit }, payload) {
		commit('setSubscriptionLoading', true);
		let { data } = await SubscriptionRepository.create(payload);
		commit('setSubscriptionData', data);
		commit('setSubscriptionLoading', false);
	},
	async reSubscription({ commit }, payload) {
		commit('setSubscriptionLoading', true);
		try {
			let { data } = await SubscriptionRepository.reSubscribe(payload);

			let snap = await usersCollection
				.where('customer_id', '==', data.subscription.customer)
				.get();
			for (let doc of snap.docs) {
				let userData = doc.data();
				userData['subscription_id'] = data.subscription.id;
				userData['subscription_plan'] = {
					price: data.subscription.plan.amount,
					interval: data.subscription.plan.nickname,
					isActive: true,
					expiry: data.subscription.current_period_end,
				};
				let obj = {
					to: userData.email,
					plan: {
						price: data.subscription.plan.amount,
						interval: data.subscription.plan.nickname,
					},
				};
				try {
					let request = await fetch(
						`${baseDomain}/sendPaymentConfirmationEmail`,
						{
							method: 'POST',
							headers: { 'Content-Type': 'application/json' },
							body: JSON.stringify(obj),
						}
					);
					await this.registers({ ...this.data, ...obj });
				} catch (err) {
					console.log(err.message);
				}
				await usersCollection.doc(doc.id).update({ ...userData });
			}
		} catch (err) {
			console.log(err.response);
		} finally {
			commit('setSubscriptionLoading', false);
		}
	},
	async unSubscribe({ commit }, payload) {
		commit('setSubscriptionLoading', true);
		let userSnap = await usersCollection.doc(payload.id).get();
		let userData = userSnap.data();
		let { subscription_plan } = userData;
		subscription_plan.isActive = false;
		userData['subscription_plan'] = subscription_plan;
		await usersCollection.doc(payload.id).set({ ...userData });
		// try {
		// 	let { data } = await SubscriptionRepository.unSubscribe(
		// 		payload.s_id
		// 	);

		// } catch (err) {
		// 	console.log(err.response);
		// } finally {
		commit('setSubscriptionLoading', false);
		// }
	},
};
let mutations = {
    setSubscriptionData(state, payload) {
        state.subscription = payload;
    },
    setSubscriptionsData(state, payload) {
        state.subscriptions = payload;
    },
    setSubscriptionLoading(state, payload) {
        state.loading = payload;
    },
    setSubscriptionsNotification(state, payload) {
        let { notification } = state;
        notification.message = payload.message;
        notification.type = payload.type;
        state.notification = notification;
        window.setTimeout(() => {
            let obj = { message: "", type: "" };
            state.notification = obj;
        }, 5000);
    },
};
export default { state, getters, actions, mutations };
